import {ModalLayout} from "../../shared/modal-layout";
import {FontAwesome5} from "@expo/vector-icons";
import {Text} from "react-native";
import * as React from "react";
import {PaymentButton} from "../screens/pickup-service/dashboard/shared/payment-button";

export const ModalAdditionalBin = ({
                                       closeModal,
                                       onPay
                                   }) => {
    return <ModalLayout title="Order an additional bin"
                        icon={<FontAwesome5 name="trash" size={24} color="#a0c946"/>}
                        close={closeModal}>
        <Text style={{fontWeight: 'bold', marginBottom: 5}}>To store more paper between each pick up</Text>
        <Text>* Delivery around 24h</Text>
        <Text style={{
            fontWeight: 'bold',
            textAlign: 'center',
            color: '#a0c946',
            fontSize: 25,
            marginBottom: 10,
            marginTop: 10
        }}>1000 Rs</Text>

        <PaymentButton product="bin" onWhite={true} onPay={async () => {
            await onPay()
            closeModal()
        }}>Start Payment</PaymentButton>
    </ModalLayout>
}